import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../../graphql.module';
import { JobPaymentFilterInput, JobPaymentSortInput } from '../../../../../../graphql';
import { GetInvoices } from '../queries/GetInvoices.generated';

@Injectable({
    providedIn: 'root',
})
export class InvoicesApiService {
    #apollo = inject(Apollo);

    private get gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    getJobInvoices(
        take: number,
        skip: number,
        search: string | null | undefined,
        status: string | null | undefined,
        order: [JobPaymentSortInput] | null | undefined,
        where: JobPaymentFilterInput
    ) {
        return this.gql.query({
            query: GetInvoices,
            variables: {
                take,
                skip,
                search,
                status,
                order,
                where,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
